'use client';

import {useEnvConfig} from '@web-catalog/env';
import dynamic from 'next/dynamic';

import useMediaQueryMatch from '@web-catalog/hooks/useMediaQueryMatch';

import {StoriesLoader} from './parts/Loader/StoriesLoader';
import styles from './Stories.module.scss';

const Impl = dynamic(
  () => import(/* webpackChunkName: "Stories" */ './Stories'),
  {
    ssr: false,
    loading: () => <StoriesLoader />,
  },
);

export const Stories = () => {
  const isTabletOrMobile = useMediaQueryMatch('(max-width: 1024px)');
  const {INS_KEY} = useEnvConfig();
  if (!isTabletOrMobile || !INS_KEY) return <div className={styles.wrapper} />;
  return <Impl />;
};
